module.exports = __webpack_public_path__ + "media/images/amenities_icons/pitching_events-d3a1f6158c173eaf3011932b79a40073.svg";